<template>
    <div class="loading">
        <a-icon :component="phonepeSvg" spin />
    </div>
</template>
     
<script>
import phonepeSvg from '../assets/phonepe.svg';
export default {
    name: 'Loading',
    data() {
        return {
            phonepeSvg,
        };
    }

}
</script>
     
<style scoped>
.loading {
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    z-index: 1000;
}
.loading i {
    position: absolute;
    top: 50%;
    left: 50%;
    font-size: 84px;
    transform: translate(-50%, -50%);
}
</style>
